import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface FilterVisibilityContextType {
  showFilters: boolean;
  toggleFilters: () => void;
  setShowFilters: (show: boolean) => void;
}

const FilterVisibilityContext = createContext<FilterVisibilityContextType>({
  showFilters: true,
  toggleFilters: () => {},
  setShowFilters: () => {}
});

export const useFilterVisibility = () => {
  const context = useContext(FilterVisibilityContext);
  if (!context) {
    console.error('useFilterVisibility must be used within a FilterVisibilityProvider');
    throw new Error('useFilterVisibility must be used within a FilterVisibilityProvider');
  }
  return context;
};

interface FilterVisibilityProviderProps {
  children: ReactNode;
}

export const FilterVisibilityProvider: React.FC<FilterVisibilityProviderProps> = ({ children }) => {
  const [showFilters, setShowFilters] = useState(true);

  const toggleFilters = useCallback(() => {
    setShowFilters(prev => {
      const newValue = !prev;
      return newValue;
    });
  }, [showFilters]);

  const value = {
    showFilters,
    toggleFilters,
    setShowFilters
  };

  
  return (
    <FilterVisibilityContext.Provider value={value}>
      {children}
    </FilterVisibilityContext.Provider>
  );
}; 